export enum AccessTypeCodes {
  SITE = "SITE",
  PROJECT = "PROJECT",
  GLOBAL = "GLOBAL",
}